module.exports = __webpack_public_path__ + "media/images/delete-green-fb549d5c.svg";